import React, {Component} from 'react'
import './RegistrationSplash.css'
import { NavLink } from 'react-router-dom'
import LogoLavoratore from '../../../assets/logo-lavoratore.png'
import LogoResidente from '../../../assets/logo-residente.png'

export default class RegistrationSplash extends Component {
  render () {
    return (
      <div className="main-container container">
        <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <div className="panel panel-default panel-border-login">
            <div className="registration-title">RESIDENTE</div>
            <div className="panel-body">
              <a href="#" className="btn-social btn-outline">
                <img className="login-admin-logo" src={LogoResidente} />
              </a>
              <div className="panel-body flex-grow panel-2" style={{paddingBottom: 36, paddingTop: 15}}>
                <div className="title-registration-box">
                  ABITI NELLE ZONE INTERESSATE DAL PIANO DI SOSTA?
                </div>
                <div className="subtitle-registration-box">
                  Esempio di testo, breve ma abbastanza esauriente da guidare l
                  'utente nella scelta del suo percorso ideale. Poche righe di testo.
                  Va indicato che accedono a questo percorso anche i titolari di attività
                  che comunque risiedono nelle zone del piano.
                </div>
              </div>
              <NavLink
                style={{display: 'block'}}
                className="resident-btn-navlink splash-login-btn"
                to={'/register/resident'}>
                <strong>REGISTRATI</strong> <span className="glyphicon glyphicon-arrow-right">{}</span>
              </NavLink>
            </div>
          </div>
        </div>

        <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <div className="panel panel-default panel-border-login">
            <div className="registration-title">LAVORATORE</div>
            <div className="panel-body">
              <a href="#" className="btn-social btn-outline">
                <img className="login-admin-logo" src={LogoLavoratore} />
              </a>
              <br />
              <div className="panel-body flex-grow panel-2" style={{marginBottom: 81}}>
                <div className="title-registration-box">
                  L'AZIENDA PER CUI LAVORI E' UBICATA NELLE ZONE INTERESSATE DAL PIANO DI SOSTA?
                </div>
                <div className="subtitle-registration-box">
                  Esempio di testo, breve ma abbastanza esauriente da guidare l
                  'utente nella scelta del suo percorso ideale. Poche righe di testo.
                </div>
              </div>
              <NavLink
                style={{display: 'block'}}
                className="resident-btn-navlink splash-login-btn"
                to={'/register/worker'}>
                <strong>REGISTRATI</strong> <span className="glyphicon glyphicon-arrow-right">{}</span>
              </NavLink>
            </div>
          </div>
        </div>
        {/* <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <div className="panel panel-default panel-border-login">
            <div className="registration-title">STANDARD</div>
            <div className="panel-body">
              <a href="#" className="btn-social btn-outline"><img className="login-admin-logo" src={LogoStandard} /></a>
              <div className="panel-body flex-grow panel-2" style={{marginBottom: 61}}>
                <div className="title-registration-box">
                  TI OCCORRE SOSTARE TEMPORANEAMENTE NELLE ZONE INTERESSATE DAL PIANO SOSTA?
                </div>
                <div className="subtitle-registration-box">
                  Esempio di testo, breve ma abbastanza esauriente da guidare l
                  'utente nella scelta del suo percorso ideale. Poche righe di testo.
                </div>
              </div>
              <NavLink
                style={{display: 'block'}}
                className="resident-btn-navlink splash-login-btn"
                to={'/register/standard'}>
                <strong>REGISTRATI</strong>
                <span className="glyphicon glyphicon-arrow-right">{}</span>
              </NavLink>
            </div>
          </div>
        </div> */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Registration/Splash/RegistrationSplash.js